<template>
  <div id="login" class="flex items-center justify-center h-screen px-12 py-12">
    <div class="w-full max-w-2xl md:w-2/3">
      <div class="flex flex-col items-center mb-10">
        <img class="h-20" :src="logo" alt="API Abroad" />
        <portal-target name="authTitle" />
      </div>
      <component
        :is="authComponent"
        :email="email"
        :passwordSet="passwordSet"
        @changeComponent="changeComponent"
        @setEmail="setEmail"
        @setPassword="setPassword"
        @logout="logout"
      />
    </div>
  </div>
</template>

<script>
import LoginForm from "../components/auth/LoginForm.vue";
import ResetForm from "../components/auth/ResetForm.vue";
import ResetConfirmation from "../components/auth/ResetConfirmation.vue";
import SetPasswordForm from "../components/auth/SetPasswordForm.vue";
import { Formio } from "formiojs";

export default {
  components: {
    "login-form": LoginForm,
    "reset-form": ResetForm,
    "reset-confirmation": ResetConfirmation,
    "set-password-form": SetPasswordForm
  },
  data() {
    return {
      authComponent: "login-form",
      email: "",
      passwordSet: false
    };
  },
  computed: {
    logo() {
      return process.env.VUE_APP_CDN_ENDPOINT + "/images/api-connect-logo.png";
    }
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        this.setComponentOnMount();
      }
    }
  },
  methods: {
    setComponentOnMount() {
      let name = this.$route.name;
      switch (name) {
        case "SignIn":
          this.authComponent = "login-form";
          break;
        case "Forgot Password":
        case "Set Password":
          this.authComponent = "reset-form";
          break;
        case "Reset Password":
          this.authComponent = "set-password-form";
          break;
        default:
          this.authComponent = "login-form";
      }
    },
    changeComponent(component) {
      this.authComponent = component;
    },
    setEmail(email) {
      this.email = email;
    },
    setPassword(isSet) {
      this.passwordSet = isSet;
    },
    logout() {
      if (
        localStorage.getItem("formioToken") ||
        localStorage.getItem("formioUser")
      ) {
        Formio.logout();
        this.$store.commit("logout");
      }
    }
  },
  mounted() {
    this.setComponentOnMount();
  }
};
</script>
